import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "./assets/css/design.css";
import "./assets/css/photoEdit_1280-1389.css";
import "./assets/css/photoEdit_1390-1620.css";
import "./assets/css/reset.min.css";
import "./assets/css/photoEdit.css";
import "./assets/css/photoEdit_767.css";
import { initializeGlobalTransportEncryption } from "./utils/requestCrypto";

initializeGlobalTransportEncryption();

// ─── Suppress third-party browser extension errors ───────────────────────────
// The Anuvadini translation extension (anuvadini_extension.js) injects a
// MutationObserver that tries to pass non-Element nodes to IntersectionObserver,
// causing a TypeError that triggers React's dev error overlay. Since we cannot
// modify the extension, we intercept and silently swallow these specific errors.
if (typeof window !== "undefined" && window.IntersectionObserver) {
  const originalObserve = window.IntersectionObserver.prototype.observe;
  window.IntersectionObserver.prototype.observe = function (target) {
    if (target instanceof Element) {
      return originalObserve.apply(this, arguments);
    }
    console.warn("IntersectionObserver.observe: Swallowed TypeError for non-Element node.");
  };
}
window.addEventListener("error", (event) => {
  if (
    event?.filename?.includes("anuvadini_extension") ||
    (event?.message?.includes("IntersectionObserver") &&
      event?.message?.includes("not of type 'Element'"))
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }
});
window.addEventListener("unhandledrejection", (event) => {
  const msg = event?.reason?.message || "";
  if (msg.includes("IntersectionObserver") && msg.includes("not of type 'Element'")) {
    event.preventDefault();
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



